__turbopack_context__.v({
  "container": "DropdownInline-module-scss-module__jTq30q__container",
});
